export const CALENDAR_WORKING_HOURS = {
  firstHour: 8,
  lastHour: 18,
} as const;

export const DAY_VIEW_HOUR_HEIGHT_PIXELS = 96;
export const WEEK_VIEW_HOUR_HEIGHT_PIXELS = 80;
export const DEFAULT_APPOINTMENT_DURATION_MINUTES = 60;

export function buildWorkingHoursSequence(): number[] {
  const hoursSequence: number[] = [];
  for (
    let hour = CALENDAR_WORKING_HOURS.firstHour;
    hour <= CALENDAR_WORKING_HOURS.lastHour;
    hour++
  ) {
    hoursSequence.push(hour);
  }
  return hoursSequence;
}
